/**
 * YOUTUBE ADS WORKSPACE — /google-ads/youtube
 *
 * The shared Google Ads workspace tree filtered to video campaigns
 * (VIDEO / DEMAND_GEN). The connect gate is YouTube's own card; everything
 * else — toolbar, stat tiles, campaign → ad group → ad rows, grid view, failed
 * drafts drawer — comes from GoogleAdsWorkspace so it cannot drift from
 * /google-ads/campaigns.
 */
import { MonitorPlay } from 'lucide-react';
import GoogleAdsWorkspace from '@/components/google-ads/GoogleAdsWorkspace';
import YouTubeConnectCard from '@/components/google-ads/youtube/YouTubeConnectCard';
import { isYoutubeCampaign, YT_BASE, YT_SUBTITLE } from '@/components/google-ads/youtube/youtubeShared';

export default function YouTubeAdsPage() {
  return (
    <GoogleAdsWorkspace
      title="YouTube Ads"
      breadcrumb="Google Ads / YouTube"
      description={YT_SUBTITLE}
      filter={isYoutubeCampaign}
      newCampaignRoute={`${YT_BASE}/create`}
      emptyIcon={MonitorPlay}
      emptyHint="Create a YouTube campaign, ad group and ad in one flow."
      viewStorageKey="yt_ads_view"
      connectSlot={(auth, accountUid, onChanged) => (
        <YouTubeConnectCard auth={auth} accountUid={accountUid} onChanged={onChanged} />
      )}
    />
  );
}
